import { ClientOnlyScope } from './client-only-scope';
import { ClientOnlyValue } from './client-only-value';
import { RowDescriptor } from './row-descriptor';
import { RowsDescriptor } from './rows-descriptor';
import { RowsDescriptorType } from './rows-descriptor-type';
import { SelectAllState } from './select-all-state';

export class UpdateRowsDescriptor<TData, TId> extends RowsDescriptor {
  constructor(
    public data: RowDescriptor<TData, TId>[],
    public offset: number,
    public totalCount: number,
    public totalSelected: number,
    public selectAllState: SelectAllState,
    public disabled = false,
    public selectAllClientOnly: null | {
      scope: ClientOnlyScope;
      value: ClientOnlyValue;
    } = null
  ) {
    super(RowsDescriptorType.Update);
  }
}
